module.exports = __webpack_public_path__ + "static/media/integrationHTML5.a0b29dc6.md";